"use client";
import styled from "@emotion/styled";
import { AxisAndBackground, PositionAndSize } from "@/types/cssTypes";
import {
  HEADER_HEIGHT,
  NEUTRO_BLANK_COLOR,
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_COLOR_DISSABLED,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";

export const CustomDiv = styled("div")<AxisAndBackground>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${({ background }) => background};
  padding-left: ${({ paddingX }) => paddingX};
  padding-right: ${({ paddingX }) => paddingX};
  padding-top: ${({ paddingY }) => paddingY};
  padding-bottom: ${({ paddingY }) => paddingY};
  margin-left: ${({ marginX }) => marginX};
  margin-right: ${({ marginX }) => marginX};
  margin-top: ${({ marginY }) => marginY};
  margin-bottom: ${({ marginY }) => marginY};
`;

export const InlineDiv = styled(CustomDiv)<AxisAndBackground>`
  position: relative;
  display: flex;
`;

export const HorizontalCenterDiv = styled("div")<AxisAndBackground>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-top: ${({ paddingY }) => paddingY};
  margin-top: ${({ marginY }) => marginY};
  width: ${({ width }) => width};
`;

export const VerticalCenterDiv = styled("div")<PositionAndSize>`
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  right: ${({ right }) => right};
  left: ${({ left }) => left};
  bottom: ${({ bottom }) => bottom};
  width: ${({ width }) => width};
  margin-left: ${({ marginX }) => marginX};
  margin-right: ${({ marginX }) => marginX};
  margin-top: ${({ marginY }) => marginY};
  margin-bottom: ${({ marginY }) => marginY};
`;

export const AbsoluteDiv = styled(CustomDiv)<PositionAndSize>`
  position: absolute;
  right: ${({ right }) => right};
  left: ${({ left }) => left};
  top: ${({ top }) => top};
  bottom: ${({ bottom }) => bottom};
`;

export const FixedFooter = styled("footer")`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const Layout = styled("div")`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 30px;
  padding-bottom: 30px;
  height: fit-content;
  min-height: calc(100vh - ${HEADER_HEIGHT});
  @media (max-width: 1200px) {
    padding-left: 3%;
    padding-right: 3%;
  }
  @media (max-width: 900px) {
    padding-left: 10%;
    padding-right: 10%;
  }

  @media (max-width: 576px) {
    padding-left: 6%;
    padding-right: 6%;
  }
`;

export const InputContainer = styled("div")`
  margin-top: 25px;
`;

export const FakeInputContainer = styled("div")<AxisAndBackground>`
  width: ${({ width }) => width};
  min-width: 200px;
  border: 1px solid ${({ color }) => color ?? PRIMARY_BUTTON_COLOR_DISSABLED};
  border-radius: 16px;
  font-style: normal;
  font-weight: 300;
  color: ${NEUTRO_TITLES_COLOR};
  height: 48px;
  padding: 0px;
  background: ${NEUTRO_BLANK_COLOR};
  font-size: 14px;
  letter-spacing: 0.3px;
  position: relative;
  display: flex;

  &:focus {
    outline: none !important;
    border: 1px solid ${PRIMARY_BUTTON_COLOR} !important;
  }

  &:hover {
    &::placeholder {
      color: ${NEUTRO_TITLES_COLOR};
    }
    border: 1px solid ${PRIMARY_BUTTON_COLOR};
  }
`;

export const Separator = styled("div")`
  width: 100%;
  height: 1px;
  margin-top: 17px;
  background: ${SECONDARY_BUTTON_COLOR};
  opacity: 0.16;
`;

export const HomeHeaderDiv = styled("div")`
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  // padding-left: 108px;
  // padding-right: 108px;
  padding-top: 0px;
  padding-bottom: 30px;
  height: auto;
  min-height: 272px;
  gap: 32px;
  background: ${NEUTRO_TITLES_COLOR};
`;

export const ResultsAsDropdownContainer = styled("div")`
  border-radius: 16px;
  background: white;
  z-index: 100;
  position: absolute;
  height: auto;
  width: 100%;
`;

export const SeparatorMini = styled("div")`
  height: 24px;
  margin-top: 20px;
  background: #0000001f;
  width: 1px;
  margin-left: 10px;
  margin-right: 10px;
`;

export const CategoryDiv = styled("div")`
 width: fit-content;
  min-width: 74px;
  max-width: 90px;
  text-wrap: balance:
  background: #3c3c3b;
  color: #ffffff;
  border-radius: 12px;
  padding: 4px 8px 4px 8px;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  line-height: 12px;
  :hover {
    background: ${PRIMARY_BUTTON_COLOR} !important;
    color: #ffffff;
  }
`;

export const CircularDiv = styled("div")<PositionAndSize>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 50px;
  background: ${({ background }) => background};
  padding-left: ${({ paddingX }) => paddingX};
  padding-right: ${({ paddingX }) => paddingX};
  display: flex;
  justify-content: center;
  align-items: center;
`;
